import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { DELETE_URL } from '@utils/api/endpoints.ts';
import { AxiosError } from 'axios';
import { BaseError } from '@utils/types/shared/base.ts';

export async function deletePreference(id: number): Promise<void> {
  await Axios.delete(DELETE_URL(id.toString()).userPreference);
}

export function useDeleteUserPreference() {
  const queryClient = useQueryClient();

  return useMutation<void, AxiosError<BaseError>, number>(deletePreference, {
    onSuccess: () => {
      queryClient.invalidateQueries(['userPreferences']);
    },
    onError: () => {},
    useErrorBoundary: false
  });
}
